//API
import { getRequest, postRequest, putRequest } from "../globalService"

const endPoint = 'payment';

// Catálogo de planes y proveedor de pago vigente. La ruta es pública, pero se manda el token:
// con él, el back responde para este coach (un coach del piloto de Stripe recibe Stripe
// aunque el proveedor general siga en PayPal). Sin sesión, el back lo trata como anónimo.
export const getPaymentConfig = ()=> {
    return getRequest(`${endPoint}/config`, true)
}

export const generateSubscription = (clientId, planId)=> {
    return postRequest(`${endPoint}/suscription/`, { clientId, planId },true)
}


export const getSubscription = (suscriptionId)=> {
    return getRequest(`${endPoint}/suscription/${suscriptionId}`,true)
}

export const paymentApprove = (coachId, dataApprove)=> {
    return postRequest(`${endPoint}/${coachId}/approve`, dataApprove,true)
}

export const cancelSubscription = (suscriptionId, coachId, body = {})=> {
    return postRequest(`${endPoint}/suscription/${suscriptionId}/${coachId}/cancel`, body, true)
}
// Stripe (los planes nuevos). Todas usan la sesión del coach.
export const stripeCheckout = (planType, interval)=> {
    return postRequest(`${endPoint}/checkout`, { planType, interval }, true)
}

// prorationDate: la de la factura que confirmó el coach (al subir de plan), para cobrar lo mismo.
export const stripeChangePlan = (planType, interval, prorationDate)=> {
    return postRequest(`${endPoint}/change-plan`, { planType, interval, ...(prorationDate ? { prorationDate } : {}) }, true)
}

// Factura que traería el cambio de plan, para confirmarlo; no cambia nada.
export const stripeChangePlanPreview = (planType, interval)=> {
    return postRequest(`${endPoint}/change-plan/preview`, { planType, interval }, true)
}

export const stripeCancel = ()=> {
    return postRequest(`${endPoint}/cancel`, {}, true)
}

export const stripePortal = ()=> {
    return postRequest(`${endPoint}/portal`, {}, true)
}
